import store from "../store/index";
//----------
// is delay
//----------
export default function isDelay(parm) {
  //--------------
  // access store
  //--------------
  const this_store = store.state.combat;
  let maxCA = this_store.config.max_ca;
  //---------------------------------------------
  // if first slot - cannot be delay before then
  //---------------------------------------------
  if (parm.num == 1) {
    return false;
  } else {
    //----------------------------
    // loop thru possible actions
    //----------------------------
    for (let k = 1; k <= maxCA; k++) {
      //------------------------------------------------------
      // check if delay still present + not this clicked slot
      //------------------------------------------------------
      let prev_slot_name = "ca_name" + k;
      if (parm.props.row[prev_slot_name] == "delay" && k != parm.num) {
        return true;
      }
    }
    return false;
  }
}
